"use strict"

import {
  isArray
} from "util";
import { eventBus } from "./eventbus";

var async = require("async")
var Loki = require('lokijs')

export default class LokiSyncDB {
  constructor(root) {
    this.vueI = root;
    this.executing = false;
    this.copyForUpdate = null;
    this.types = {
      "_ORDER": "order",
      "_ADDRESS": "address",
      "_USER": "user"
    }
    this._PROD = true;
    this.startingNewPolling = false;
    this.reSyncImmediately = false;
    this.max = 0;
    this.old_new_index = {};
  }
  triggerUpdate() {
    if(this.executing){
      // se una front end sync sta già eseguendo, non forzo nulla
      // segnalo solo alla funzione di polling, di rieseguire immediatamente la sync, invece di aspettare i ms indicati
      console.log("*sync* _____ SETUP IMMEDIATE RESYNC ______")
      this.reSyncImmediately = true;
    } else {
      console.log("*sync* _____ FORCING REMOTE SYNC REGISTRY WITH NEW LOOP ORDER ______")
      var newLoopOrder = (this.max + 1);
      this.max = newLoopOrder;
      console.log("*sync* LOOP " + newLoopOrder + " _____ SYNC BEFORE IDLE ______")
      this.remoteSyncRegistry().then(()=> {
        // è importante usare gli stessi millisecondi usati in AppOnlineLoaderMixin.js
        var millisec;
        if(this.vueI.preferences.deferredInterval){
            millisec = Number(this.vueI.preferences.deferredInterval) * 1000 * 60 // (ms - s - m)
        } else {
            millisec = 60000
        }
        if(this.reSyncImmediately) millisec = 1;
        this.startSyncDefferredPolling(millisec, newLoopOrder)
        eventBus.$emit('remoteSyncRegistryResolved')
      })
    }
    // NOTA: se trigger update venisse invocato più volte, prima della risoluzione della remotesync, troverà sicuramente executing true
  }
  remoteSyncRegistry() {
    var updatePath = null;
    var reg = this.vueI.dbRegistry;
    var registryCollection = this.vueI.dataReferences.getCollection("singleRegistry");
    var reg_record = registryCollection.find({
      "name": this.vueI.getRegistryIdentifier()
    })[0];
    // Riferimenti a registry in memoria e al record di met-info sull'IDB
    console.log("*sync* REMOTE SYNC LOKI: " + new Date(reg_record.lastSync))
    var vueI = this.vueI;
    var ls = this;

    // La procedura di Sync ritorna una promise, così da eseguire eventuali operazioni al termine
    return new Promise(function (resolve, reject) {
      // a questo punto, le modifiche sono nel record corretto della collezione "storedChanges", a seconda che ci sia o meno una sync in corso

      if (ls.executing) {
        console.log("*sync* Sync already executing")
        resolve();
      } else {
        // controllo ulteriori modifiche locali da serializzare

        console.log("*sync* Serializing ->", vueI.dbRegistry)

        var localChanges = ls.serializeLocalChanges(true);
        if (localChanges) {

          localChanges = ls.factorChanges(localChanges);
          localChanges = JSON.stringify(localChanges);
          console.log("*sync* Sending Changes: ", localChanges)

        }
        vueI.executingSync = true;
        ls.executing = true;
        ls.copyForUpdate = new Loki("copyForUpdate");
        var set = reg.listCollections();
        for (var i = 0; i < set.length; i++) {
          var setn = set[i].name;
          var c = reg.getCollection(setn);

          if (!c.disableChangesApi) {
            // per ogni collezione con sync bidirezionale attiva, creo una collezione copiando le configurazioni, i dati e rigenero gli indici
            // lo faccio prima della della risoluzione delle promise, così ho modo di distinguere le modifiche da bo (+ locali da sincronizzare) ...
            // ... da tutte quelle che avvengono durante la chiamata o durante il loop per l'inserimento dei dati aggiornati
            var indexes = []
            if (c.binaryIndices) {
              for (var prop in c.binaryIndices) {
                if (c.binaryIndices[prop].name) {
                  indexes.push(prop);
                }
              }
            }
            var options = {
              disableChangesApi: false,
              disableMeta: false,
              unique: c.uniqueNames && c.uniqueNames.length > 0 ? c.uniqueNames : null,
              indices: indexes && indexes.length > 0 ? indexes : null
            }
            if (!options.unique) delete options.unique;
            if (!options.indices) delete options.indices;

            var c_u = ls.copyForUpdate.addCollection(setn, options);
            var copy = c.data.slice()
            c_u.data = copy;
            vueI.restoreCollection(c_u)
          }
        }

        // copyForUpdate avrà solo le collezione con sincronizzazione bidirezionali
        // applicherò le modifiche in arrivo da service (che siano in risposta alla modifica client o da backoffice) solo su copy for Update
        reg.clearChanges();
        ls.copyForUpdate.clearChanges();
        
        if(!vueI.token.regCrDate){
          alert('!!!!!!! vueI.token.regCrDate ',vueI.token.regCrDate)
        }
        console.log('!!!!!!! vueI.token.regCrDate ', Number(vueI.token.regCrDate))
        
        // prima di lanciare la sync, cancello le modifiche attive sul registry (sono comunque salvate ancora in localChanges)
        // in questo modo riesco a distinguere le modifiche che verran rilevate in seguito (a sync in corso)
        vueI.microservice({
          role: "sync",
          cmd: "FrontEndSync",
          params: {
            type: "registry", //per ora l'unico supportato
            name: vueI.token.registryCliente, // frontEndSync ha bisogno del nome del file registry, il riferimento nel token dovrà essere aggiornato di conseguenza alla sync
            lastSync: reg_record.lastSync ? reg_record.lastSync : Number(vueI.token.regCrDate), // in millisecondi
            agid: vueI.token.idAgente && vueI.token.idAgente != "null" ? vueI.token.idAgente : null,
            cliid: vueI.token.idCliente,
            stv: vueI.front_end_configs.struct_vers, 
            changes: localChanges
          }
        }).then((response) => {

          var res = response
          try {
           res = response.body;
            try {
              res = JSON.parse(response.body);
            } catch (err) {}
          } catch(err){
            console.log("*sync* FrontEndSync response empty: ", res)
          }
          
          console.log("*sync* REGISTRY REMOTE CHANGES:", res);
          
          if (res && res.tryAgain) {
            var attempt = ls.getMainChanges();
            console.log("*sync* ATTEMPTED ", attempt);
            if (attempt.length > 0) {
              var set = reg.listCollections();

              for (var i = 0; i < set.length; i++) {
                var setn = set[i].name;
                var c = reg.getCollection(setn);

                if (!c.disableChangesApi) {
                  var retryChanges = attempt.filter(function (obj) {
                    return obj.name == setn;
                  })
                  console.log("*sync* as of " + setn)
                  console.log("*sync*: ", retryChanges);
                  if (retryChanges.length > 0) {
                    c.changes = retryChanges.concat(c.changes);
                    console.log("*sync* after concat: ", c.changes)
                  }
                }
              }
            }

            ls.executing = false;
            resolve();
          } else {
            if (res && res.trackErrors) {
              console.log("*sync* FrontEndSync - TRACK_ERRORS: ", res.trackErrors)
              var s = []

              for (var i = 0; i < res.trackErrors.length; i++) {
                var te = res.trackErrors[i];
                var msg = vueI.$Jed.firstUpperTranslate(te.msg, null)
                var typ = vueI.$Jed.firstUpperTranslate(ls.types[te.type], null)
                var news = "<li>" + msg + ", " + typ + ": <strong>" + te.id + "</strong>";
                if (!ls._PROD) {
                  news += " -> " + te.detail + "</li>"
                } else {
                  news += "</li>"
                }
                s.push(news);
              }
              s = s.join("");
              vueI.simpleNotification("error", {
                title: vueI.$Jed.firstUpperTranslate('sync error report', null),
                message: ("<ul>" + s + "</ul>"),
                timeout: false
              })
            }
            //cmd ritorna loki di modifiche e data sincronizzazione
            var changes = null;
            var changesLoadPromise = new Promise(function (resolveChanges, rejectChanges) {
              if (res && res.changesPath) {
                updatePath = res.changesPath;
                res.changesPath = res.changesPath.split("\\").pop();
                changes = vueI.loadLoki(vueI.msPath + "/" + res.changesPath, "soloDestructured", false, false).then((reg) => {
                  changes = reg;
                  resolveChanges()
                }, (err) => {
                  console.log("*sync* Error loading Changes Loki from Services: ", err)
                  resolveChanges()
                })
              } else {
                console.log("*sync* res && res.changesPath: ", (res && res.changesPath))
                resolveChanges()
              }
            });

            changesLoadPromise.then(() => {
              /*
              vueI.microservice({
                role: "sync",
                cmd: "ClearUpdateRegistry",
                params: {
                  delete: updatePath
                }
              }).then(() => {}, () => {});
              */

              var cols = changes ? changes.listCollections() : []
              // keys è una collezione creata al volo dal cmd che riporta i campi identificativi di ogni collection
              var keys = changes ? changes.getCollection("keys") : []
              console.log("*sync* changes from remote: ", changes)
              //monitor
              var inserted = 0;
              var updated = 0;
              var deleted = 0;

              var parallelCollectionLoops = [];
              for (var i = 0; i < cols.length; i++) {
                parallelCollectionLoops.push(new Promise(function (resolveLoop, rejectLoop) {
                  var colname = cols[i].name;
                  console.log("*sync* Merging " + colname)
                  // applico le modifiche per ogni collection diversa da keys 
                  if (colname != "keys" && colname != "deletions") {
                    var pk;
                    try {
                      pk = keys.find({
                        name: colname
                      })[0].primary;
                    } catch (err) {
                      console.log("*sync* collection " + colname + " not syncronized");
                      console.log("*sync* ", err)
                    }
                    // se non trovo in keys il record associato alla collezione, non ho modo di identificare i record originali da modificare
                    if (pk) {
                      //array modifiche collection
                      var col = changes.getCollection(colname).data;
                      //collection originale da aggiornare
                      var target_col = reg.getCollection(colname);
                      if (target_col) {
                        if (!target_col.disableChangesApi) {
                          target_col = ls.copyForUpdate.getCollection(colname)
                        }
                        console.log("*sync* copyForUpdate: ", ls.copyForUpdate)

                        async.eachSeries(col, function (record, callback) {
                          delete record.$loki

                          if (target_col.disableChangesApi) {
                            var findObj = {}
                            for (var ii in pk) {
                              // creo l'oggetto di query usando i valori delle chiavi primarie
                              findObj[pk[ii]] = record[pk[ii]];
                            }

                            try {
                              // se il record originale NON esiste, e la modifica non è in cancellazione
                              inserted++;
                              // inserisco un nuovo record
                              target_col.insert(record);
                              //console.log(colname + " insert ended in " + (Date.now() - bef) + " ms");
                            } catch (err) {
                              //console.log("err inserting record on sync, probably existing record")
                              //console.log(err)
                              inserted--;

                              var target = target_col.find(findObj)
                              if (target) {
                                target = target[0];
                                var id_loki = target.$loki;
                                target = record;
                                target.$loki = id_loki;
                                updated++;
                                // aggiorno il record con le prop modificate
                                target_col.update(target)
                              }
                            }
                          } else {
                            //devo trattare le collezione per la sync bidirezionale in modo diverso, il vincolo unique a quanto pare non viene rispettato
                            if (record.OLDID) {
                              record.NEWID = record.id;
                              record.id = record.OLDID;
                              if(colname == "orders"){
                                vueI.ids = {new: record.NEWID, old: record.id}
                              }
                            }
                            var findObj = {}
                            for (var ii in pk) {
                              // i valori delle chiavi primarie possono essere corretti con i nuovi id scirtti da DB, la search ha tuttavia bisogno del vecchio riferimento
                              findObj[pk[ii]] = record[pk[ii]];
                            }
                            var target = target_col.find(findObj)
                            if (target && target.length > 0) {
                              target = target[0];
                              var id_loki = target.$loki;
                              target = record;
                              target.$loki = id_loki;
                              if (target.OLDID) {
                                target.id = target.NEWID;
                                
                                if(!ls.old_new_index[colname]) ls.old_new_index[colname] = {}
                                ls.old_new_index[colname][target.OLDID] = target.NEWID

                                delete target.OLDID;
                                delete target.NEWID;
                              }
                              updated++;
                              console.log("*sync* overriding: ", target)
                              // aggiorno il record con le prop modificate
                              target_col.update(target)
                            } else {
                              inserted++;
                              target_col.insert(record);
                            }
                          }

                          setTimeout(function () {
                            callback();
                          }, 1)
                        }, function (err) {
                          console.log("*sync* " + colname + " SERIES ENDED");
                          if (err) {
                            console.log("*sync* ... WITH ERR: ", err);
                          }
                          resolveLoop();
                        })
                      } else {
                        console.log("*sync* " + colname + " should not be synced");
                        resolveLoop();
                      }

                    } else {
                      resolveLoop();
                    }
                  } else if (colname == "deletions") {
                    var del = changes.getCollection("deletions").data;
                    console.log("*sync* Front end Sync deletions: ", del)
                    for (var ii = 0; ii < del.length; ii++) {
                      var d = {};
                      try {
                        d = JSON.parse(del[ii].key);
                      } catch (err) {}
                      var findObj = {};
                      for (var index in d) {
                        findObj[d[index].cna] = d[index].val;
                      }
                      var targetC = reg.getCollection(del[ii].coln);
                      if (targetC) {
                        if (!targetC.disableChangesApi) {
                          targetC = ls.copyForUpdate.getCollection(del[ii].coln)
                          console.log("*sync* targetCollection: ", targetC)
                        }
                        var target = targetC.find(findObj)
                        if (target.length == 0) {
                          for (var clause in findObj) {
                            if (clause == "id" && !isNaN(Number(findObj.id))) { // TODO: SHOULD CHANGE DELETION TRIGGER ?
                              findObj.id = Number(findObj.id);
                              target = targetC.find(findObj);
                            }
                          }
                        }
                        if (target && target.length > 0) {
                          if (target.length > 1) {
                            console.log("*sync* Warn, various removable target found: ", target)
                          }
                          target = target[0]
                          targetC.remove(target)
                          console.log("*sync* succesfully removing: ", target)
                        } else {
                          console.log("*sync* removing target not found with query : ", findObj)
                        }
                      } else {
                        console.log("*sync* target collection " + del[ii].coln + " not found for deletion")
                      }
                    }
                    resolveLoop();
                  } else {
                    resolveLoop();
                  }
                }))
              }


              Promise.all(parallelCollectionLoops).then(() => {
                // a questo punto, nel registry ci saranno le modifiche applicate dalla sync nelle collezioni "non bi", e le eventuali modifiche da UI
                // le modifiche da sync per le collezioni "bi", son rilevate come changes in copyForUpdate
                var copies = ls.copyForUpdate.listCollections();
                for (var i = 0; i < copies.length; i++) {
                  console.log("*sync* Step into -> " + copies[i].name)
                  var targetRegistryCollection = reg.getCollection(copies[i].name);
                  var copyChanges = ls.copyForUpdate.generateChangesNotification([copies[i].name])
                  var originalChanges = reg.generateChangesNotification([copies[i].name]);
                  console.log("*sync* Changes from UI: ", originalChanges);
                  console.log("*sync* Changes from sync: ", copyChanges)
                  if (copyChanges && copyChanges.length > 0) {

                    // mi assicuro che le modifiche avvenute tra la chiamata e la fine del loop di insert, vengano salvato nel record apposito "pending" dell'indexedDB
                    ls.serializeLocalChanges();
                    var backupChanges = targetRegistryCollection.changes;
                    if (backupChanges && backupChanges.length > 0) {
                      backupChanges = backupChanges.slice();
                    } else {
                      backupChanges = null;
                    }

                    // applico le modifiche rilevate nella copia del db (quelle provenienti da bo e/o appena sincronizzate correttamente)
                    ls.applyChangesSeries(copyChanges, targetRegistryCollection, false)

                    // elimino i riferimenti alle modifiche appena applicate così da rilevare quelle da ui (con priorità più alta)
                    //reg.clearChanges();
                    targetRegistryCollection.flushChanges()

                    if (originalChanges && originalChanges.length > 0) {
                      // se ce ne sono, riapplico in ordine le modifiche fatte durante la procedura di sync, così saranno rilevate come "recenti" e da sincronizzare alla prossima chiamata
                      ls.applyChangesSeries(originalChanges, targetRegistryCollection, true)
                      targetRegistryCollection.changes = backupChanges;
                    }

                  } else {
                    // non chiamo clearChanges, perchè in questo caso le uniche attiva sono quelle avvenute da UI nel frattempo
                    // non riapplico alcuna notifica, la prossima serialize rileverà correttamente le modifiche come da "sincronizzare"
                  }

                }
                ls.old_new_index = {}
                console.log("*sync* ----- SYNC PROMISE ALL RESOLVED -----")
                console.log("*sync* Update Registry: ", reg);
                // aggiorno il record nell'IDB, con syncTime e loki aggiornati
                reg_record.lastSync = res.syncTime;
                console.log("*sync* UPDATING SYNC RECORD: ", reg_record)
                registryCollection.update(reg_record)

                /*
                //emetto gotChanges in modo da aggiornare subito le variabili in memoria
                console.log(changes)
                if(changes){
                  eventBus.$emit('gotChanges', vueI.ids) //se è stato syncr un ordine, mi porto dietro il vecchio id e il nuovo id (mi serve per riaccedere al dettaglio dopo la sync)
                }
                */

                reg.saveDatabase(function (err) {
                  if (err) {
                    console.log("*sync* Error saving local registry post sync: ", err)
                  }
                  ls.executing = false;
                  var end = ls.serializeLocalChanges();
                  console.log("*sync* after Save Database: ", end)
                  if(changes){
                    
                    //Ricontrollo id di shopCartData
                    //TODO: forse si può fare se id è negativo?
                    if(vueI.shopCartData){
                      var reg_orders = reg.getCollection('orders'),
                        reg_order_items = reg.getCollection('orderItems'),
                        order = reg_orders.find({'$loki': vueI.shopCartData.$loki})  //uso $loki perchè questo serve per aggiornare le schermate quando ho inserito un prodotto in carrello e ancora ci sono gli id provvisori (negativi) per ordine e righeordine
                      if(order){
                          //console.log("** ORDER FOUND ** ")
                      } 
                      if(order && order[0]){
                          vueI.shopCartData.id = order[0].id; //imposto il nuovo id per la struttura che rappresenta il carrello (cioè ShopCartData) così posso usare questa proprietà per recuperare il record dall'idb quando serve
                          vueI.shopCartData.riferimento = order[0].id; //aggiorno i campi della videata che potrebbero avere subito delle modifiche con la sync bi-dir

                          var order_items = reg_order_items.find({oid: order[0].id});
                          if(order_items.length>0){
                              //aggiorno gli id dei prodotti nella struttura che rappresenta il carrello
                              for(var i = 0; i < order_items.length; i++){
                                  for(var j = 0; j < vueI.shopCartData.prodotti.length; j++){
                                      if(order_items[i].pid == vueI.shopCartData.prodotti[j].codiceProd){
                                        vueI.shopCartData.prodotti[j].id = order_items[i].id
                                      }
                                  }
                              }
                          }
                      }
                      eventBus.$emit('gotChanges', vueI.ids) //se è stato syncr un ordine, mi porto dietro il vecchio id e il nuovo id (mi serve per riaccedere al dettaglio dopo la sync)
                 
                    }
                  } 
                  
                  //risolvo la promise di Sync
                  resolve();
                });

                vueI.simpleNotification("info", {
                  title: "DEV",
                  message: 'Sync Report: Update (' + updated + ') -  Insert (' + inserted + ')  -  Delete (' + deleted + ')',
                })
              }, (err) => {
                console.log("*sync* ----- SYNC PROMISE ALL ERROR -----, ", err)
                //risolvo la promise di Sync
                ls.executing = false;
                resolve();
              })

            })
          }
        })
        .catch(err => {
          console.log("*sync* err: ", err);
          var msg = err && err.body && err.body.error ? err.body.error : ''
          eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "sync.FrontEndSync - " + msg +'</h5>',
              type: "error",
              action: ''
          })
          resolve();
        });
      }
    });
  }
  startSyncDefferredPolling(ms, order){
    var loopOrder = order;
    if(!loopOrder) loopOrder = this.max

    var ls = this;
    setTimeout(function () {
      if(loopOrder < ls.max){
        // se ho appena forzato una nuova front end sync dopo la saveDatabase, e sono chiamato da un eventuale vecchio polling...
        //---> INTERROMPO IL POLLING
        //------------------------------
        // controllo l'ordine del loop per capire se è necessario interromperlo (ce n'è uno maggiore)
        console.log("*sync* LOOP " + loopOrder + " _____ OLD SYNC IDLE STOPPED ______")
       } else {
        console.log("*sync* LOOP " + loopOrder + " _____ DEFFERED IDLE ______")
        
        ls.remoteSyncRegistry().then(() => {
          // polling riparte solo dopo la risoluzione della Sync
          // reSyncImmediately è true solo se executing = true, ossia quando nessun nuovo ordine è creato, gli ms cambiano eventualmente qui
          var deferring = ms
          if(ls.reSyncImmediately){
            deferring = 1;
            ls.reSyncImmediately = false;
            console.log("*sync* _____ RESYNC IMMEDIATELY ______ ")
          } else {
            if(ls.vueI.preferences.deferredInterval){
              deferring = Number(ls.vueI.preferences.deferredInterval) * 1000 * 60 // (ms - s - m)
            } else {
              deferring = 60000
            }
          }
          ls.startSyncDefferredPolling(deferring, loopOrder) // ** richiamo il polling sempre con gli ms calcolati e l'ordine del loop corrente
           // così facendo, non ci saranno mai due polling contemporanei, il secondo interromperà sempre il primo
        })
      }
    }, ms) // ** timeout di ms indicati, oppure immediatamente se un upload forzato è in attesa
  }
  serializeLocalChanges(saveOnBackup) {
    // forse non serve, non se la fe sync chiama la serialize a sua volte e le modifiche non si perdono...
    var some = this.vueI.dbRegistry.serializeChanges()
    var sc = null;
    if (this.vueI.dataReferences.getCollection("storedChanges")) {
      sc = this.vueI.dataReferences.getCollection("storedChanges");
    } else {
      sc = this.vueI.dataReferences.addCollection("storedChanges");
    }
    var flag = this.executing ? "pending" : "main"
    if (saveOnBackup) {
      flag = "backup"
    }
    var where = {
      "flag": flag
    }
    var r = sc.find(where);
    if (r && r.length) {
      var up = r[0];
      up.changes = some;
      sc.update(up);
    } else {
      sc.insert({
        "flag": flag,
        "changes": some
      })
    }
    return some;
  }
  pollingChangesSerializeStart() {
    this.notifierStamp = 1;
    this.pollingChangesSerialize()
  }
  pollingChangesSerialize() {
    var vm = this;
    setTimeout(function () {
      var temp = vm.serializeLocalChanges();
      vm.notifierStamp = ((vm.notifierStamp + 1) % 5)
      if (vm.notifierStamp == 0) {
        var parsed = vm.factorChanges(temp)
        var count = {
          I: 0,
          U: 0,
          R: 0
        };
        for (var i = 0; i < parsed.length; i++) {
          count[parsed[i].operation]++;
        }

        vm.vueI.simpleNotification("info", {
          title: "Changes",
          message: 'Serialize Report: Update (' + count.U + ')  -  Insert (' + count.I + ')  -  Delete (' + count.R + ')'
        })

      } else {}
      vm.pollingChangesSerialize();
    }, 5000);
  }
  factorChanges(changes) {
    try {
      changes = JSON.parse(changes);
      for (var i = 0; i < changes.length; i++) {
        var parsing = changes[i];
        if (parsing.operation == "I") {
          for (var ii = (i + 1); ii < changes.length; ii++) {
            var checking = changes[ii];
            if (checking.name == parsing.name && checking.obj.$loki == parsing.obj.$loki) {
              if (checking.operation == "U") {
                parsing.obj = checking.obj;
                checking.setForDeletion = -1;
              } else if (checking.operation == "R") {
                parsing.setForDeletion = -1;
                checking.setForDeletion = -1;
              }
            }
          }
        }
      }
      // unisco gli update e elimino le rimozioni fatte sull'elemento appena inserito
      changes = changes.filter(function (o) {
        return o.setForDeletion != -1; 
      })

      for(var i = 0; i < changes.length; i++){
        var parsing = changes[i];
        if(parsing.operation == "U" && parsing.setForDeletion != -1){
          var keeping = i;
          var removed = false;
          for (var ii = 0; ii < changes.length; ii++) {
            if(i != ii){
              var checking = changes[ii];
              if (checking.name == parsing.name && checking.obj.$loki == parsing.obj.$loki) {
                if (checking.operation == "U") {
                  var d1 = new Date(checking.obj.mdt)
                  var d2 = new Date(changes[keeping].obj.mdt)
                  if(d1 > d2 || d2 == "Invalid Date"){
                    console.log("*sync* setting older update for deletion -> ", changes[keeping])
                    changes[keeping].setForDeletion = -1;
                    keeping = ii;
                  } else {
                    console.log("*sync* found older update for deletion -> ", checking)
                    checking.setForDeletion = -1;
                  }
                } else if(checking.operation == "R"){
                  removed = true;
                }
              }
            }
          }
          if(removed){
            console.log("*sync* setting recent update for deletion -> ", checking)
            changes[keeping].setForDeletion = -1;
          }
        }
      }
      // sullo stesso record, se c'è mantengo solo la rimozione, altrimenti l'update più recente
      changes = changes.filter(function (o) {
        return o.setForDeletion != -1; 
      })

      changes = changes.map(function (o) {
        try {
          if (o.obj.meta.updated) {
            o.obj.mdt = new Date(o.obj.meta.updated).toISOString();
          } else if (o.obj.meta.created) {
            o.obj.mdt = new Date(o.obj.meta.created).toISOString();
          }
        } catch (err) {
          console.log("*sync* Could not update mdt -> ", err)
        }
        console.log("*sync* mapping change: ", o)
        return o;
      })
    } catch (err) {
      console.log("*sync* Err factoring changes -> ", err);
    }
    return changes

  }
  applyChangesSeries(changes, coll, fromUI) {
    console.log("*sync* Invoked series apply with -> ", changes)
    changes.sort(function (a, b) {
      return a.operation < b.operation ? -1 : 1;
    })
    for (var i = 0; i < changes.length; i++) {
      var c = changes[i];
      switch (c.operation) {
        case "I":
          if (!fromUI) {
            console.log("*sync* Inserting ", c)
            delete c.obj.$loki;
            delete c.obj.meta;
            coll.insert(c.obj)
          } else {
            // gli inserimenti da UI non devono essere rieseguiti, in quanto il record non sarà sicuramente stato influenzato dalle modifiche da BO
            // occorre però salvarsi l'array delle modifiche 
          }
          // se l'inserimento + di una riga ordine, ed è stato effettuato durante la sincronizzazione di un nuovo ordine, avrà oid negativo, e quindi da aggiornare
          if(c.name == "orderItems"){ // eccezione per orderItems, che deve anche sostituite oid se ancora non sincronizzato
            if(c.obj.oid < 0){
              console.log("*sync* updating unsyncronized ORDER ITEMS with oid: ", c.obj.oid)
              var newOIDmapped = this.old_new_index["orders"][c.obj.oid]
              if(newOIDmapped){
                console.log("*sync* found old->new mapping OID in: ", this.old_new_index["orders"])
                c.obj.oid = newOIDmapped
              } else {
                console.log("*sync* __ERR___ NOT found old->new mapping OID in: ", this.old_new_index["orders"])
              }
              coll.update(c.obj)
            }
          }
          break;
        case "U":
          console.log("*sync* Updating ", c)
          try {
            if(c.obj.id < 0){
              console.log("*sync* updating unsyncronized record with id: ", c.obj.id)
              if(this.old_new_index[c.name]){
                var newIDmapped = this.old_new_index[c.name][c.obj.id]
                if(newIDmapped){
                  console.log("*sync* found old->new mapping in: ", this.old_new_index[c.name])
                  c.obj.id = newIDmapped
                  if(c.name == "orderItems"){ // eccezione per orderItems, che deve anche sostituite oid se ancora non sincronizzato
                    if(c.obj.oid < 0){
                      console.log("*sync* updating unsyncronized ORDER ITEMS with oid: ", c.obj.oid)
                      var newOIDmapped = this.old_new_index["orders"][c.obj.oid]
                      if(newOIDmapped){
                        console.log("*sync* found old->new mapping OID in: ", this.old_new_index["orders"])
                        c.obj.oid = newOIDmapped
                      } else {
                        console.log("*sync* __ERR___ NOT found old->new mapping OID in: ", this.old_new_index["orders"])
                      }
                    }
                  }
                } else {
                  console.log("*sync* NOT found old->new mapping in: ", this.old_new_index[c.name])
                }
              } else {
                console.log("*sync* index not found, updating same unsyncronized record")
              }
            }
            coll.update(c.obj)
          } catch (err) {
            console.log("*sync* Error Updating Bi-Record: ", err)
            console.log("*sync* Previsto se il record è stato recentemente eliminato")
          }
          break;
        case "R":
          console.log("*sync* Deleting ", c)
          if (!fromUI) {
            coll.remove(c.obj)
          }
          break;
        default:
          break;
      }
    }
  }
  getMainChanges() {
    var sc = this.vueI.dataReferences.getCollection("storedChanges");
    if (sc) {
      var pending = sc.find({
        "flag": "backup"
      });
      
      if (pending && pending.length) {
        var pendingChanges = pending[0].changes;
        try {
          pendingChanges = JSON.parse(pendingChanges);
        } catch (err) {}
        if (pendingChanges) {
          return pendingChanges;
        }
      }
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/LokiSyncDB.js